import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import Pagination from './../shared/pagination'
import Loader from './../shared/loader'

import {
  Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import download from 'downloadjs';

export default {
  name: 'rackZoneMaster',
  components: {
    Pagination,
    VueElementLoading,
    Multiselect,
    Loader
  },
  data: function() {
    return {
      file: '',
      warehouseid: '',
      status: '',
      modalShow: false,
      resultCount: '',
      totalCount: '',
      createdbyuserid: '',
      addrackmodal: false,
      isLoading: false,
      is_Loading: false,
      listWarehouseData: [],
      warehouse: '',
      warehouseModal: '',
      zoneName: '',
      rackListData: [],
      rackListData: [],
      username: '',
      zone: '',
      listZoneData: '',
      totalrows: 0,
      totalPage: 0,
      pageLimit: 10,
      currentPage: 1,
      rackName: '',
      modalShowDelete: false,
      showSelectWarehouse: false,
      warehouseError: '',
      delRackNo: '',
      warehousesearch: '',
      delId: '',
      changestatus: '',

    }
  },
  created: function() {},
  mounted() {
    var permissionEncrypt = window.localStorage.getItem('userdetail');
    var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.warehouseid = userdetail.warehouseid;
    this.createdbyuserid = userdetail.userid;
    this.username = userdetail.fullname;
    // this.getWarehouseList()
    this.user_type = userdetail.utype;
    switch (this.user_type) {
      case 'system_user':
        // this.showSelectClient = true;
        this.showSelectWarehouse = true;
        this.getWarehouseList();
        break;

      case 'client_user':

        this.getWarehouseList();
        this.showSelectWarehouse = true;
        break;

      case 'warehouse_user':
        this.loginUserEmail = userdetail.email;
        this.warehouseid = userdetail.warehouseid;
        // this.warehouse = this.warehouseid;
        this.showSelectWarehouse = false;
        this.getRacklist();

        break;

      default:
        this.$alertify.error("Unauthorised user, Please contact your system admin");
        break
    }
  },
  computed: {

  },
  methods: {

    closeStatusRackModal() {
      this.modalShow = false
    },
    closeRackDetailModal() {
      this.addrackmodal = false;

    },

    onPageChange(page) {
      this.currentPage = page;
      this.getRacklist()
    },

    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
      //  var data = this.listStockReportData;
      var csvData = ''
      //Header
      if (this.title != null) {
        csvData += this.parseExtraData(this.title, '${data}\r\n')
      }
      //Fields Names
      csvfield.forEach(function(fields) {
        if (skipFilter.indexOf(fields.fieldColumn) == -1) {
          csvData += fields.fieldColumn + ','
        }
      });

      csvData = csvData.slice(0, csvData.length - 1)
      csvData += '\r\n'
      // CSV Data
      data.map(function(item) {
        var i = 0;
        var escapedCSV = ''
        for (let key in item) {
          if (skipFilter.indexOf(key) == -1) {
            escapedCSV = item[key] + '' // cast Numbers to string
            if (escapedCSV.match(/[,"\n]/)) {
              escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
            }
            if (escapedCSV == 'null')
              csvData += ',';
            else {
              if (dateFilder.indexOf(key) != -1)
                csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ','
              else
                csvData += escapedCSV + ','
            }
          }
          i++;
        }
        csvData = csvData.slice(0, csvData.length - 1)
        csvData += '\r\n'
      })
      //Footer
      if (this.footer != null) {
        csvData += this.parseExtraData(this.footer, '${data}\r\n')
      }
      filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
      return this.export(csvData, filename, "application/csv");
      return csvData
    },
    export (data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
    },
    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },
    downloadRacks() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getConsoRackCreationTemplete',
          'data': {
            'warehouseid': this.warehouseid,
            'type': 'racks'
          },
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then((result) => {
          if (result.data.data[0].status) {
            let templateResult = [];
            result.data.data[0].data.forEach(function(field) {
              templateResult.push({
                'fieldIndex': field.csv_col_name,
                'fieldColumn': field.db_col_name

              });
            });
            this.jsonToCSV('RackIdTemplate', [], templateResult, [], []);
          } else {
            this.$alertify.error(result.data.data[0].msg);
            return false;
          }
        })
    },

    submitFile() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      if (this.file == '' || this.$refs.file.files[0].type != 'text/csv') {
        this.$alertify.error("Please select csv file!");
        return false;
      }
      this.isLoading = true;
			if(this.showSelectWarehouse == true){
				this.warehouseid =this.warehouseModal
			}
      if (document.getElementById('downloadBtn'))
        document.getElementById('downloadBtn').disabled = false;
      var formData = new FormData();

      formData.append('csv', this.file);
      formData.append('warehouseid', this.warehouseid);

      axios.post(apiUrl.api_url + 'uploadConsoRacksWarehouseWise',
          formData, {
            headers: {
              'Authorization': 'Bearer ' + myStr,
              'Content-Type': 'multipart/form-data'
            }
          })
        .then((response) => {
          this.file = ''
          document.getElementById('file').value = '';
          response = response.data.data[0];

          if (response.status == true) {
            this.$alertify.success(response.data.total_items_created.length + "  Added ,    " + "     " + response.data.total_items_updated.length + " Updated ,   " + "     " + response.data.total_items_rejected.length + " Failed")
            this.addrackmodal = false
            this.getRacklist();
          } else {
            this.$alertify.error("Racks Failed")
          }

          this.isLoading = false;
        })
        .catch(function() {

          this.$alertify.error("Racks Failed")
          this.isLoading = false;
        });
    },

    saveAddModal() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitFile()
          return false;
        } else {
          return false;
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
    resetFilter() {
      this.warehousesearch = '';
      this.rackName = '';
      this.warehouseError = '';
      this.totalCount = 0;
      this.rackListData = [];
      this.getRacklist();
      this.$validator.reset();
    },
    addNewConsoRack() {
      this.addrackmodal = true
      this.warehouseModal = ''
      this.$validator.reset();
    },
    getStatusRowData(data) {
      this.modalShow = true
      this.id = data.id
      this.status = data.status
      if (this.status.trim() == 'active' || this.status.trim() == 'Active') {
        this.changestatus = 'De-Activate'
      } else {
        this.changestatus = 'Activate'
      }
    },
    changeRackStatus() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'updateConsoRackStatus',
          'data': {
            'id': this.id,
            'status': this.status.trim(),
          },
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then((response) => {
          if (response.data.msg > 0) {
            this.$alertify.success("Rack Status update Successfully")
            this.addmodalShow = false
            this.getRacklist();
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    getRacklistSearch() {
      this.currentPage = 1;
      this.pageCount = 0;
      this.searchFlag = true;
      this.getRacklist();
    },
    getRacklist() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      if (this.warehousesearch == '' && this.showSelectWarehouse == true) {
        this.warehouseError = 'Warehouse ID is required';
        this.pageno = this.pageCount = 0;
        this.rackListData = [];
        return false;
      }
      if (this.showSelectWarehouse == true) {
        this.warehouseid = this.warehousesearch
      }

      this.input = ({
        offset: (this.currentPage - 1) * 10,
        limit: 10,
        consorackid: this.rackName.trim(),
        warehouseid: this.warehouseid,
      })
      this.isLoading = true;
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getRacklist',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.rackListData = result.data.data
          this.isLoading = false;
          this.totalCount = result.data.count
          this.resultCount = result.data.count;
          if (this.totalCount < 10) {
            this.totalPage = 1
          } else {
            this.totalPage = Math.ceil(this.totalCount / 10);
          }
        }, error => {
          console.error(error)
        })
    },
    async getWarehouseList() {
      try {
        this.isLoading = true
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '')
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
          'data': {},
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        this.listWarehouseData = result.data.data;
        this.isLoading = false
      } catch (err) {
        console.log(err);
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/consorackmaster/consorackmaster.component.js